import React from 'react';
import {Platform, View} from 'react-native';
import {Text} from '../../../../shared/components/text';
import {useStyles} from '../../../../shared/hooks/styles';
import {images} from '../../../../assets/icons';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {Button} from '../../../../shared/components/button';
import {Link} from '../../../../shared/components/link';
import {getDobroruLink} from '../../../../redux/actions/dobroru';

import {useAppDispatch} from '../../../../redux';
import {useTheme} from '../../../../shared/theme';

export const Login = () => {
  const theme = useTheme();
  const styles = useStyles(({mediaOnly}) => ({
    root: mediaOnly(DeviceSize.desktop, {flexDirection: 'row', alignItems: 'center'}),
    description: mediaOnly(
      DeviceSize.desktop,
      {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 412,
        borderRightWidth: 1,
        borderRightColor: theme.color.borderColor,
        paddingRight: 24,
        marginRight: 30,
      },
      {marginTop: 20, marginBottom: 30},
    ),
    logo: {
      marginBottom: 20,
    },
    descriptionText: {
      color: theme.color.labelText,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
    },
    link: {
      transform: [{translateY: Platform.OS === 'web' ? 0 : Platform.OS === 'ios' ? 3 : 6}],
      color: theme.color.primaryColor,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
    },
    logoButton: {
      flexShrink: 1,
      flexDirection: 'column',
    },
    loginButton: mediaOnly(
      DeviceSize.desktop,
      {width: 290},
      {width: '100%', maxWidth: 360, marginBottom: 30, marginHorizontal: 0},
    ),
  }));

  const dispatch = useAppDispatch();
  const onLogin = () => {
    dispatch(getDobroruLink());
  };

  return (
    <View style={styles.root}>
      <ResponsiveView exclude={[DeviceSize.desktop]}>
        <images.DobroRuLogo width={154} height={67} color={theme.color.dobroRuIcon} />
      </ResponsiveView>
      <View style={styles.description}>
        <Text style={styles.descriptionText}>
          Зарегистрируйтесь на портале{' '}
          <Link external href='https://dobro.ru/' testID='volunteers-dobroru-href'>
            <Text style={styles.link}>добро.рф</Text>
          </Link>
          , введите свой ID в личном профиле ЕСК СО и пользуйтесь всеми доступными сервисами программы лояльности,
          следите за различными событиями региона, отслеживайте количество отработанных волонтерских часов.
        </Text>
      </View>
      <View style={styles.logoButton}>
        <ResponsiveView only={[DeviceSize.desktop]}>
          <View style={styles.logo}>
            <images.DobroRuLogo width={93} height={40} color={theme.color.dobroRuIcon} />
          </View>
        </ResponsiveView>
        <Button
          onPress={onLogin}
          id='volunteers-my-events-nav-button'
          type='primary'
          text='Войти с помощью Добро.рф'
          style={styles.loginButton}
        />
      </View>
    </View>
  );
};
